// @flow

import React from "react";

import PostWidgetChatBubble from "./post-widget-chat-bubble";
import PostWidgetInfoSection from "./post-widget-info-section";

const SECONDS_PER_HOUR = 3600;

export type Props = $Exact<{
  value: string | number,
  required: boolean,
  options: Object,
  onChange: (value: number | string) => {},
}>;

export class SecondsAsHoursInput extends React.Component<Props> {
  toHours = (seconds: number | string) =>
    Number.parseFloat(
      Number.parseFloat((parseFloat(seconds) / SECONDS_PER_HOUR).toString()).toFixed(2),
    );

  toSeconds = (hours: string | number) => parseFloat(hours) * SECONDS_PER_HOUR;

  handleChange = (event: SyntheticEvent<HTMLInputElement>) => {
    this.props.onChange(
      !isNaN(event.currentTarget.value)
        ? this.toSeconds(+event.currentTarget.value)
        : this.props.value,
    );
  };

  render() {
    return (
      <React.Fragment>
        <div className="form-control__with-label">
          <input
            type="number"
            className="form-control"
            value={this.toHours(this.props.value) || null}
            required={this.props.required}
            onChange={this.handleChange}
          />
          <label>hours</label>
        </div>
        <PostWidgetChatBubble options={this.props.options} />
        <PostWidgetInfoSection options={this.props.options} />
      </React.Fragment>
    );
  }
}

export default SecondsAsHoursInput;
